import { FirefoxSVG, ChromeSVG, RightArrowSVG, EdgeSVG, OperaGXSVG } from "../../../assets/iconSvg";
import ButtonIcon from "../../../components/container/button";
import Carousel from "../../../components/container/carousel";
import HeadLayout from "../../../components/layout/RootLayout";
import { isEdge, isFirefox, isOperaGX } from "../../../utils/browerType";
import './checkey.css';

const pageChildren = () => {
  const images = ["/checkey/checkey_eg.png"];
  
  const chromeLink = (
    <a href="https://chromewebstore.google.com/detail/checkey/gfpbhgnhliielafioekjempmbjolheof?hl=es" className="inline-block">
      <ButtonIcon color={"#0071c2"} title="Download">
        <RightArrowSVG />
        <ChromeSVG />
      </ButtonIcon>
    </a>
  );

  const firefoxLink = (
    <a href="https://addons.mozilla.org/es/firefox/addon/checkey/" className="inline-block">
      <ButtonIcon color={"#0071c2"} title="Download">
        <RightArrowSVG />
        <FirefoxSVG />
      </ButtonIcon>
    </a>
  );

  const edgeLink = (
    <a href="https://chromewebstore.google.com/detail/checkey/gfpbhgnhliielafioekjempmbjolheof?hl=es" className="inline-block">
      <ButtonIcon color={"#0071c2"} title="Download">
        <RightArrowSVG />
        <EdgeSVG />
      </ButtonIcon>
    </a>
  );

  const operaLink = (
    <a href="https://chromewebstore.google.com/detail/checkey/gfpbhgnhliielafioekjempmbjolheof?hl=es" className="inline-block">
      <ButtonIcon color={"#0071c2"} title="Download">
        <RightArrowSVG />
        <OperaGXSVG />
      </ButtonIcon>
    </a>
  );

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row gap-8 md:gap-12 mb-16">
        <div className="w-full md:w-1/2 flex flex-col">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">Checkey</h1>
            <p className="text-xl text-gray-700 dark:text-gray-300 mb-6">All game key prices in one place</p>
            
            <div className="flex flex-wrap gap-3 mb-8">
              {isFirefox() && firefoxLink}
              {isEdge() && edgeLink}
              {isOperaGX() && operaLink}
              {!isOperaGX() && !isEdge() && !isFirefox() && chromeLink}
            </div>
          </div>
          
          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6 mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Key Features</h2>
            <ul className="space-y-3 text-gray-700 dark:text-gray-300">
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Search and compare key prices across various online stores</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Steam integration to verify availability of activatable keys</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Real-time price updates</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Trustpilot integration to read store reviews</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Color-coded distinction between official and unofficial resellers</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>SteamDB redirection to view historical prices alongside current Steam prices</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Donation button to support platform development</span>
              </li>
            </ul>
          </div>
          
          <div className="bg-gray-50 dark:bg-gray-800/40 rounded-xl p-6">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Important Note</h2>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              This extension provides prices from stores and does not guarantee product authenticity. 
              A game's absence from the list does not necessarily imply its unavailability. 
              It is recommended to verify the seller's authenticity and/or reputation before making a purchase.
            </p>
          </div>
        </div>
        
        <div className="w-full md:w-1/2 flex items-center justify-center">
          <div className="w-full max-w-lg overflow-hidden rounded-xl shadow-lg bg-white dark:bg-gray-800">
            <Carousel images={images} />
          </div>
        </div>
      </div>
      
      {/* Additional Information Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Supported Browsers</h3>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center">
              <ChromeSVG />
              <span className="ml-2 text-gray-700 dark:text-gray-300">Chrome</span>
            </div>
            <div className="flex items-center">
              <FirefoxSVG />
              <span className="ml-2 text-gray-700 dark:text-gray-300">Firefox</span>
            </div>
            <div className="flex items-center">
              <EdgeSVG />
              <span className="ml-2 text-gray-700 dark:text-gray-300">Edge</span>
            </div>
            <div className="flex items-center">
              <OperaGXSVG />
              <span className="ml-2 text-gray-700 dark:text-gray-300">Opera</span>
            </div>
          </div>
        </div>
        
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Version</h3>
          <p className="text-gray-700 dark:text-gray-300">Current version: 4.1.2</p>
          <p className="text-gray-700 dark:text-gray-300">Last updated: Dec 2024</p>
        </div>
        
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Support</h3>
          <p className="text-gray-700 dark:text-gray-300 mb-3">Having issues or questions about Checkey?</p>
          <a href="/projects/checkey/faq" className="text-blue-600 dark:text-blue-400 hover:underline">
            View FAQ →
          </a>
        </div>
      </div>
    </div>
  );
};

function Checkey() {
  return (
    <HeadLayout 
      title="Checkey | Leonardo Capone" 
      description="Checkey is a browser extension that helps you find the best prices for game keys across multiple online stores."
      keywords="Checkey, game keys, price comparison, browser extension, Steam, Chrome extension, Firefox addon"
    >
      {pageChildren()}
    </HeadLayout>
  );
}

export default Checkey;
